import {
  type LngLat,
  type MapLocationRequest,
  Lead,
  lngLatsToBounds,
  MapMarker,
  Slot,
  Text,
  Typography,
} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import {type ReactElement, type ReactNode} from 'react'

import type {PickupPointFeature} from '../../types'
import {PointMarker} from '../PointMarker/PointMarker'
import {toBoundsLocation, toCenterLocation} from '../utils'
import * as classes from './MapModePoints.classes'

export function renderCluster(onLocationChange?: (location: MapLocationRequest) => void) {
  return function _renderCluster(coordinates: LngLat, features: PickupPointFeature[]): ReactElement {
    const clickHandler = onLocationChange
      ? function clusterClickHandler() {
          if (features.length > 1) {
            const bounds = lngLatsToBounds(
              features.map(feature => feature.geometry.coordinates),
              true,
            )

            if (bounds) {
              onLocationChange(toBoundsLocation(bounds))
              return
            }
          }

          onLocationChange(toCenterLocation(coordinates, 16))
        }
      : undefined

    return (
      <PointMarker coordinates={coordinates} onClick={clickHandler} type="numeric">
        {features.length}
      </PointMarker>
    )
  }
}

type MarkerParams = {
  children: ReactNode
  selectedFeature?: PickupPointFeature
  onFeatureClick(feature: PickupPointFeature): void
}

export function renderMarker({onFeatureClick, selectedFeature, children}: MarkerParams) {
  return function _renderMarker(feature: PickupPointFeature): ReactElement {
    const clickHandler = () => {
      onFeatureClick(feature)
    }
    const selected = feature === selectedFeature
    const size = selected ? 'm' : 'xs'

    return (
      <MapMarker coordinates={feature.geometry.coordinates} onClick={clickHandler}>
        <div className={classes.markerRoot}>
          <Slot className={clsx(classes.slotMarker, classes.slotMarkerSize[size])} size={size}>
            <Lead>
              <div
                className={clsx(classes.icon, classes.iconSize[size], classes.iconType[feature.pickupPoint._type])}
              />
            </Lead>
            {selected && (
              <Text
                // @ts-expect-error Property 'Component' does not exist on type...
                Component={Typography}
                ml="xs"
                thickness="medium"
                variant="caption1"
              >
                {children}
              </Text>
            )}
          </Slot>
          {selected && <div className={classes.tail} />}
        </div>
      </MapMarker>
    )
  }
}
